import { useTranslation } from '@mint-lib/i18n';
import { Avatar, AvatarFallback, AvatarImage } from '@mint-lib/tw-components';

import SpeakerChip from '../SpeakerChip/SpeakerChip.jsx';

type Props = {
  avatar: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  isActive: boolean;
  className?: string;
};

const UserSpeakerChip = ({
  firstName,
  lastName,
  avatar,
  className,
  isActive,
}: Props) => {
  const { t } = useTranslation('@mint-lib/tw-components');
  return (
    <SpeakerChip className={className} isActive={isActive}>
      <Avatar size={'small'} className={'cursor-default'}>
        <AvatarImage src={avatar} />
        <AvatarFallback firstName={firstName} lastName={lastName} />
      </Avatar>
      {t('You')}
    </SpeakerChip>
  );
};

export default UserSpeakerChip;
